import { render, staticRenderFns } from "./UserSnackbar.vue?vue&type=template&id=53bd4bc0"
import script from "./UserSnackbar.vue?vue&type=script&lang=js"
export * from "./UserSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bd4bc0')) {
      api.createRecord('53bd4bc0', component.options)
    } else {
      api.reload('53bd4bc0', component.options)
    }
    module.hot.accept("./UserSnackbar.vue?vue&type=template&id=53bd4bc0", function () {
      api.rerender('53bd4bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserSnackbar.vue"
export default component.exports